// extracted by mini-css-extract-plugin
module.exports = {"item":"CategroyList_item__25Aa3"};